import qs from "qs";

export const sanitizeLocationSearch = (search) => {
    const { snippet, area, "view-file": viewFile, highlight, ...rest } = qs.parse(search, {
        ignoreQueryPrefix: true,
    });
    return qs.stringify(rest);
};
